// extracted by mini-css-extract-plugin
export default {"container":"hXMwGOQYwBP0H0S7LsEQ"};